import { useEffect, useState } from 'react'

interface MicrophonePermissionState {
  hasPermission: boolean | null // null = checking, true = granted, false = denied
  isChecking: boolean
  error: string | null
}

export const useMicrophonePermission = () => {
  const [state, setState] = useState<MicrophonePermissionState>({
    hasPermission: null,
    isChecking: true,
    error: null,
  })

  useEffect(() => {
    let isMounted = true

    const checkPermission = async () => {
      try {
        // Try to get microphone access
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        })

        // Permission granted - stop the stream immediately
        stream.getTracks().forEach(track => track.stop())

        if (isMounted) {
          setState({
            hasPermission: true,
            isChecking: false,
            error: null,
          })
        }
      } catch (error) {
        console.error('Microphone permission error:', error)

        if (isMounted) {
          const errorMessage =
            error instanceof Error ? error.message : 'Unknown error'

          setState({
            hasPermission: false,
            isChecking: false,
            error: errorMessage,
          })
        }
      }
    }

    checkPermission().catch(error => {
      console.error('Failed to check microphone permission:', error)
    })

    return () => {
      isMounted = false
    }
  }, [])

  return state
}
